<template>
    <div>
        <HomeNav v-if="userNotLoggedin == true" />
        <header class="masthead mb-auto" v-if="userNotLoggedin == false">
            <nav class="navbar navbar-expand-lg navbar-dark bg-no-trans">
                <div class="container">
                    <a class="navbar-brand" href="/#/">
                        <img src="../assets/img/logo.png" alt="Logo" />
                    </a>
                    <div class="my-2 my-lg-0">
                        <button
                            class="btn btn-light btn-sm my-2 my-sm-0"
                            @click="gotoLogin"
                        >
                            login
                        </button>
                    </div>
                </div>
            </nav>
        </header>
        <section class="pricing-container d-flex flex-column">
            <div class="mt-auto flex-shrink-0">
                <div class="container py-5">
                    <div class="row justify-content-center">
                        <div class="col-md-12 col-lg-6 col-xl-6">
                            <h3 class="mt-5 text-white text-center">
                                Hi <span v-if="userNotLoggedin">{{ username }}</span>
                            </h3>
                            <p class="text-white text-center">What answers do you need?</p>
                            <div class="input-group my-5 search">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="inputGroup-sizing-default">
                                        <i class="fa fa-search"></i>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    class="form-control"
                                    placeholder="Search for keywords and phrases"
                                    aria-label="Recipient's username"
                                    aria-describedby="basic-addon2"
                                    v-model="search"
									@keyup="searchQuery()"
                                />
                                <div class="input-group-append">
                                    <button class="btn btn-outline-light" type="button" @click="searchQuery()">Search</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="mt-auto nav-bg">
                <div class="container">
                    <ul
                        class="nav help-tabs justify-content-center"
                        id="pills-tab"
                        role="tablist"
                    >
                        <li class="nav-item mr-5">
                            <a
                                class="nav-link help "
                                data-toggle="pill"
                                href="#mediacenter"
                                role="tab"
                                aria-selected="false"
								@click="gotoLink(2)"
                                >MEDIA CENTER</a
                            >
                        </li>
                        <li class="nav-item">
                            <a
                                class="nav-link faq active"
                                data-toggle="pill"
                                href="#faqs"
                                aria-selected="true"
                                role="tab"
								@click="gotoLink(1)"
                                >FAQS</a
                            >
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="detail-block tab-content" id="pills-tabContent">
            <div class="container tab-pane fade show active" id="faqs">
                <div class="row accordion ">
                    <div class="col-md-12 col-lg-6">
                        <div class="mb-3" v-for="(card, index) in faqrow1" :key="index">
                            <div class="card-header">
                                <a
                                    class="collapsed"
                                    data-toggle="collapse"
                                    :href="getCollapsExample(card.id)"
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls="collapseExample"
                                >
                                    {{ card.languages[0].title }}
                                </a>
                            </div>
                            <div class="collapse" :id="getCollapsid(card.id)">
                                <div class="card-body" v-html="card.richTextData"></div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 col-lg-6">
                        <div class="mb-3" v-for="(card, index) in faqrow2" :key="index">
                            <div class="card-header">
                                <a
                                    class="collapsed"
                                    data-toggle="collapse"
                                    :href="getCollapsExample(card.id)"
                                    role="button"
                                    aria-expanded="false"
                                    aria-controls="collapseExample"
                                >
                                    {{ card.languages[0].title }}
                                </a>
                            </div>
                            <div class="collapse" :id="getCollapsid(card.id)">
                                <div class="card-body" v-html="card.richTextData"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <p class="font14 linkhelp mt-5">
                    ... Or you can go to our
                    <a class="link" href="/#/mediacenter">Media Center</a>
                </p>
            </div>
            <div class="container tab-pane fade " id="mediacenter">
                <div class="row mt-5">
					<div
						class="col-sm-12 col-md-12 col-lg-6 col-xl-6 mt-2"
						v-for="(card, index) in mediacenter"
						:key="index"
					>
						<div class="card episode rounded">
							<div
								class="card-img-top"
								v-html="decodeHTMLEntities(card.richTextData)"
							></div>
							<div class="card-footer text-white bg-primary">
								{{ card.languages[0].title }}
							</div>
						</div>
					</div>
					
				</div>
                
                <p class="font14 linkfaq">
                    ... Or you can go to our
                    <a href="/#/faqs" @click="reload" class="link">Frequently Asked Questions.</a>

                </p>
            </div>
        </section>
    </div>
</template>

<style scoped>
.linkhelp{
	color: var(--text-primary-color) !important;
}
.linkfaq{
	color: var(--text-primary-color) !important;
}
.pricing-container {
	background-color: #80b440;
}

.bg-primary {
	background-color:#679F3D !important;
}

.btn-primary {
	background-color: #80b440;
}

.detail-block {
	padding-top: 4rem !important;
	padding-bottom: 4rem !important;
	min-height: 80vh;
}
.card-img-top p {
	margin-bottom: 0;
}

@media only screen and (max-width: 1024px) {
  .pricing-container {
    width: 100%;
  }
  .detail-block{
	  width: 100%;
  }
   
}

</style>

<script>
import HomeNav from "@/components/HomeNav.vue";
import Fuse from "fuse.js";
export default {
	name: "faq",
	components: {
		HomeNav,
	},
	computed: {
	userNotLoggedin() {

			if( this.$store.state.user.logedin){
				return true
			} else{
				return false
			}
		},
		username() {
			return this.$store.state.user.userInfo.name.split(" ")[0];
		},
	},
	created() {
		this.$store.commit("showdefaultFooter", true);
		this.getDataByTag1("faqrow1");
		this.getDataByTag2("faqrow2");
        this.getDataByTag3("mediaquery");
		this.showfaq1 = true;
		//  this.faqrow2 = this.getDataByTag('faqrow1');
	},
	mounted() {
		
		window.scroll(0, 0);
	},

	methods: {
		reload(){
			window.location.reload()
		},
		getCollapsExample(id) {
			return "#collapseExample" + id;
		},
		getCollapsid(id) {
			return "collapseExample" + id;
		},
		getDataByTag1(tag) {
			var data = null;
			this.$store.dispatch("getblogsByTag", tag).then((res) => {
				this.faqrow1 = res;
                this.tempFaqrow1=res
			});
		},
		getDataByTag2(tag) {
			var data = null;
			this.$store.dispatch("getblogsByTag", tag).then((res) => {
				this.faqrow2 = res;
                this.tempFaqrow2=res;
			});
		},
        getDataByTag3(tag) {
			this.$store.dispatch("getblogsByTag", tag).then((res) => {
				this.mediacenter = res;
				this.tempMediaCenter=res
			});
		},
		gotoLogin() {
			this.$router.push("/login");
		},
		removeErr() {
			this.showresmsg = false;
		},
		ValidateEmail(mail) {
			var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
			if (mail.match(mailformat)) {
				return true;
			} else {
				// alert("You have entered an invalid email address!");
				return false;
			}
		},
		gotoLink(id) {
			if (id == 1) {
				this.$router.push("/faqs");
			} else {
				this.$router.push("/mediacenter");
				}
		},
		contact() {
			this.isActive = true;
			self.showerr = false;
			if (this.docontact) {
				var DataToSend = {
					phone: "",
					email: this.email,
					description: this.msg,
					title: this.subject,
				};

				self = this;
				if (this.ValidateEmail(DataToSend.email)) {
					this.$store.dispatch("contactus", DataToSend).then((res) => {
						self.showresmsg = "Your email has been sent to site admin";
						self.showerr = true;
					});
				} else {
					self.showresmsg = "Invalid Email Entred";
					self.showerr = true;
				}
			}
		},
        decodeHTMLEntities(text) {
			var textArea = document.createElement("textarea");
			textArea.innerHTML = text;
			return textArea.value;
		},
		searchQuery() {
			if (this.search !== "") {
				const searchresult = new Fuse(this.mediacenter, {
					keys: [
						"languages.title",
						"excerpt",
						"slug"
					],
				}).search(this.search);
				this.mediacenter = searchresult.map((result) => {
					return result.item;
				});
				const faqrow1Searchresult = new Fuse(this.faqrow1, {
					keys: [
						"languages.title",
						"excerpt",
						"slug"
					],
				}).search(this.search);
				this.faqrow1 = faqrow1Searchresult.map((result) => {
					return result.item;
				});
				const faqrow2Searchresult = new Fuse(this.faqrow2, {
					keys: [
						"languages.title",
						"excerpt",
						"slug"
					],
				}).search(this.search);
				this.faqrow2 = faqrow2Searchresult.map((result) => {
					return result.item;
				});
			}

			if (this.search == "") {
				this.mediacenter = this.tempMediaCenter
				this.faqrow1=this.tempFaqrow1;
				this.faqrow2=this.tempFaqrow2;
			}
		},
	},

	data() {
		return {
			lengthCount: 0,
			idcount: 0,
			faqrow1: null,
			faqrow2: null,
			showfaq1: false,
			isActive: false,
			docontact: true,
			userid: "",
			password: "",
			title: "",
			email: "",
			phno: "",
			subject: "",
			msg: "",
			showerr: false,
			showresmsg: "",
            mediacenter: null,
			search: "",
			tempMediaCenter:null,
			tempFaqrow1:null,
			tempFaqrow2:null
		};
	},
};
</script>
